var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "coupon-container full-height" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: "2%",
            width: "80%",
            visible: _vm.dialogFormVisible,
            title: "優惠票券維護",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            open: _vm.clearFiles,
          },
        },
        [
          _c("coupon-data", {
            ref: "couponDataRef",
            attrs: {
              categories: _vm.categories,
              formData: _vm.formData,
              fatherDialogFormVisible: _vm.fatherDialogFormVisible,
              saveSuccess: _vm.saveSuccess,
            },
          }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入票券名稱" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getList },
          }),
          _c("el-button", {
            attrs: {
              type: "warning",
              circle: "",
              icon: "el-icon-plus",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.addData },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
          _c("NotificationHistory", { staticClass: "notification-history" }),
        ],
        1
      ),
      _c("el-alert", {
        staticStyle: {
          "background-color": "#ffd643",
          color: "#4b4b4b",
          "margin-bottom": "10px",
        },
        attrs: {
          closable: false,
          title: "排序可設定小數點，數字越小會排在前面",
          type: "info",
          effect: "dark",
        },
      }),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "73%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                new Date() > new Date(scope.row.endDate)
                                  ? "gray"
                                  : "inherit",
                              textDecoration:
                                new Date() > new Date(scope.row.endDate)
                                  ? "line-through"
                                  : "none",
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "票券名稱", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                new Date() > new Date(scope.row.endDate)
                                  ? "gray"
                                  : "inherit",
                              textDecoration:
                                new Date() > new Date(scope.row.endDate)
                                  ? "line-through"
                                  : "none",
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.couponName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "開放日期", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                new Date() > new Date(scope.row.endDate)
                                  ? "gray"
                                  : "inherit",
                              textDecoration:
                                new Date() > new Date(scope.row.endDate)
                                  ? "line-through"
                                  : "none",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.beginDate) +
                                " 至 " +
                                _vm._s(scope.row.endDate) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkPermission(["ITA-DEV", "APP-ADMIN", "ITA-ADMIN"])
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "票券地點" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  style: {
                                    color:
                                      new Date() > new Date(scope.row.endDate)
                                        ? "gray"
                                        : "inherit",
                                    textDecoration:
                                      new Date() > new Date(scope.row.endDate)
                                        ? "line-through"
                                        : "none",
                                  },
                                },
                                [_vm._v(" " + _vm._s(scope.row.position) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      406534829
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "排序", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                new Date() > new Date(scope.row.endDate)
                                  ? "gray"
                                  : "inherit",
                              textDecoration:
                                new Date() > new Date(scope.row.endDate)
                                  ? "line-through"
                                  : "none",
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.sort) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkPermission([
                "ITA-DEV",
                "APP-ADMIN",
                "ITA-ADMIN",
                "ITA-ADM-STAFF",
              ])
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "旅行社" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.agencyTravelInfo.agencyName
                                ? _c("el-tag", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.agencyTravelInfo.agencyName
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      905798051
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "設為問卷使用", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.showToSurvey
                          ? _c("i", {
                              staticClass: "el-icon-star-on",
                              staticStyle: {
                                "font-size": "18px",
                                color: "#ff6d6d",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            style: {
                              backgroundColor:
                                new Date() > new Date(scope.row.endDate)
                                  ? "gray"
                                  : "",
                              borderColor:
                                new Date() > new Date(scope.row.endDate)
                                  ? "gray"
                                  : "#13ce66",
                            },
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  new Date() > new Date(scope.row.endDate)
                                    ? "查看"
                                    : "編輯"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "刪除", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteData(scope.row)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "發送推播", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("NotificationSetting", {
                          attrs: { data: scope.row },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }